"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableItem = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ConfiguratorContext_1 = require("./ConfiguratorContext");
const DraggableItem = ({ children, item, props }) => {
    const configurator = (0, ConfiguratorContext_1.useConfiguratorContext)();
    const dragging = (0, react_1.useRef)(false);
    const setDragging = (value) => { dragging.current = value; };
    return (react_1.default.createElement(Container, { draggable: "true", onDrag: () => {
            if (dragging.current)
                return;
            setDragging(true);
            configurator.setIncomingItem(item, props);
        }, onDragEnd: () => {
            setDragging(false);
            configurator.setIncomingItem(undefined);
        } }, children));
};
exports.DraggableItem = DraggableItem;
const Container = styled_components_1.default.div `
  cursor: pointer;
  touch-action: pan-x;

  :active {
    cursor: grabbing;
  }
`;
